import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import TintingOptions from './components/TintingOptions';
import Shades from './components/Shades';
import Comparison from './components/Comparison';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <TintingOptions />
      <Shades />
      <Comparison />
      <Contact />
      <Footer />
      <Toaster 
        position="top-center"
        richColors
        closeButton
        theme="dark"
      />
    </div>
  );
}

export default App;